import { ProjectStopsSchedulingDtoModelType } from '../../models/ProjectStopsSchedulingDtoModel';
import { assignStopsFailedNotification } from '../../../../notifications/scheduling/assignStops';
import getAppEnv from '../../utils/getAppEnv';
import { SolutionActionStatus } from '../../../../constants';

export default ({ store, pendingSolution }: ProjectStopsSchedulingDtoModelType) => {
  const appEnv = getAppEnv(store);
  const action = pendingSolution.assignAction;
  const status = pendingSolution.solutionStatus?.name;

  if (action && status) {
    const visitCount = action.details?.eventUuids?.length;

    if (status === SolutionActionStatus.FAILED && visitCount) {
      appEnv.notification(assignStopsFailedNotification(pendingSolution.id, visitCount));
    }
  }

  return () => {
    store.assignActionStatusDtos.delete(pendingSolution.assignAction.id);
    store.solutionStatusOnlyDtos.delete(pendingSolution.id);
  };
};
